import { atomWithStorage } from "jotai/utils";

export const skipDislikeConfirmAtom = atomWithStorage<boolean>("skipDislikeConfirm", false);
